import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { centralizedClipWorkspaceIdSelector } from '~/store/centralizedClip/selectors';
import { makeAssetTransformationTasksSelectorByWorkspaceId } from '~/store/tasks/selectors';
import { TRANSFORM_TYPE as CLIP_VIDEO_TRANSFORM_TYPE } from '~/swr-hooks/clips/useCreateVideoClipTask';
import { useAirStore } from '~/utils/ReduxUtils';
import { useCancelTask } from '~/utils/taskUtils/useCancelTask';

export const useRemoveAssetTransformationTasksForVersion = () => {
  const { cancelTask } = useCancelTask();
  const store = useAirStore();
  const workspaceId = useSelector(centralizedClipWorkspaceIdSelector);
  const tasksSelector = useMemo(() => makeAssetTransformationTasksSelectorByWorkspaceId(workspaceId), [workspaceId]);

  const removeTasks = useCallback(
    ({ assetVersionId }: { assetVersionId: string }) => {
      const taskIds = tasksSelector(store.getState())
        .filter(
          ({ metadata }) =>
            'assetVersionId' in metadata &&
            metadata.assetVersionId === assetVersionId &&
            metadata.transformType !== CLIP_VIDEO_TRANSFORM_TYPE &&
            metadata.transformType !== 'captionVideo',
        )
        .map(({ localTaskId }) => localTaskId);

      if (taskIds.length > 0) {
        taskIds.forEach((taskId) => {
          cancelTask(taskId);
        });
      }
    },
    [cancelTask, store, tasksSelector],
  );

  return { removeTasks };
};
